<template>
    <div class="d-flex flex-column fill-height tutorials-page">
        <v-row>
            <v-col cols="12" class="d-flex">
                <div style="width: 100%; display: flex; box-shadow: none">
                    <app-card :contentStyle="'padding: 8px; overflow: inherit;'" contentIsScrollable="false">

                        <template v-slot:title>
                            <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1">
                                {{ $t('tutorials.title') }}
                            </v-card-title>
                        </template>

                        <template v-slot:content>
                            <v-row class="mx-0 my-0 d-sm-flex flex-sm-column">

                                <!-- ── Barra de Filtros ── -->
                                <v-col cols="12" class="pb-2 pt-2">
                                    <v-row align="center" no-gutters>
                                        <!-- Pesquisa -->
                                        <v-col cols="12" sm="5" md="4" class="pr-sm-3 mb-2 mb-sm-0">
                                            <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                :label="$t('tutorials.search')"
                                                single-line
                                                hide-details
                                                outlined
                                                dense
                                                class="rounded-lg"
                                                @input="onSearchInput"
                                            ></v-text-field>
                                        </v-col>

                                        <!-- Filtros direita -->
                                        <v-col cols="12" sm="7" md="8" class="d-flex align-center flex-wrap" style="gap: 8px">
                                            <!-- Label Idioma -->
                                            <span class="text-caption grey--text text--darken-1 mr-1 d-none d-sm-inline">{{ $t('tutorials.language') }}</span>

                                            <!-- Filtro de Idioma -->
                                            <v-btn-toggle v-model="selectedLang" dense class="filter-toggle mr-3">
                                                <v-btn value="all" small class="text-none filter-btn">
                                                    {{ $t('table.all') }}
                                                </v-btn>
                                                <v-btn value="pt" small class="text-none filter-btn">
                                                    <v-avatar size="16" class="mr-1">
                                                        <v-img src="https://flagcdn.com/w40/pt.png"></v-img>
                                                    </v-avatar>
                                                    PT
                                                </v-btn>
                                                <v-btn value="en" small class="text-none filter-btn">
                                                    <v-avatar size="16" class="mr-1">
                                                        <v-img src="https://flagcdn.com/w40/gb.png"></v-img>
                                                    </v-avatar>
                                                    EN
                                                </v-btn>
                                            </v-btn-toggle>

                                            <!-- Separador -->
                                            <v-divider vertical class="mx-1 d-none d-sm-flex" style="height: 24px"></v-divider>

                                            <!-- Label Ordenação -->
                                            <span class="text-caption grey--text text--darken-1 mr-1 d-none d-sm-inline">{{ $t('tutorials.sort') }}</span>

                                            <!-- Ordenação -->
                                            <v-btn-toggle v-model="sortOrder" mandatory dense class="filter-toggle">
                                                <v-btn value="az" small class="text-none filter-btn">
                                                    <v-icon x-small class="mr-1">mdi-sort-alphabetical-ascending</v-icon>
                                                    A-Z
                                                </v-btn>
                                                <v-btn value="za" small class="text-none filter-btn">
                                                    <v-icon x-small class="mr-1">mdi-sort-alphabetical-descending</v-icon>
                                                    Z-A
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-divider class="mx-3 mb-4"></v-divider>

                                <!-- ── Loading ── -->
                                <v-col v-if="isLoading" cols="12" class="d-flex justify-center align-center py-12">
                                    <v-progress-circular indeterminate color="#006DB6" size="48"></v-progress-circular>
                                </v-col>

                                <!-- ── Sem resultados ── -->
                                <v-col v-else-if="!isLoading && sortedCategories.length === 0" cols="12" class="d-flex flex-column align-center py-12">
                                    <v-icon size="64" color="grey lighten-1">mdi-video-off-outline</v-icon>
                                    <span class="grey--text mt-3">{{ $t('tutorials.none') }}</span>
                                </v-col>

                                <!-- ── Categorias e Vídeos ── -->
                                <div class="categories-scroll-wrapper" v-else>
                                <template >
                                    <v-col
                                        v-for="(category, index) in sortedCategories"
                                        :key="category.id"
                                        cols="12"
                                        :class="index > 0 ? 'mt-4' : ''"
                                    >
                                        <!-- Título da Categoria -->
                                        <div class="d-flex align-center mb-4">
                                            <span class="title-text dark-blue-color mr-4" style="white-space: nowrap; font-size: 1.1rem; font-weight: 700">
                                                {{ tb(category.name) }}
                                            </span>
                                            <v-divider></v-divider>
                                            <span class="grey--text text--lighten-1 ml-3 text-caption" style="white-space: nowrap">
                                                {{ $tc('tutorials.videoCount', category.items.length, { n: category.items.length }) }}
                                            </span>
                                        </div>

                                        <!-- Grid de Vídeos -->
                                        <v-row>
                                            <v-col
                                                v-for="video in category.items"
                                                :key="video.id"
                                                cols="12"
                                                sm="6"
                                                md="4"
                                                lg="3"
                                                class="d-flex"
                                                style="min-width: 0"
                                            >
                                                <v-card
                                                    class="video-card rounded-xl"
                                                    elevation="2"
                                                    width="100%"
                                                    @click="openVideo(video)"
                                                >
                                                    <!-- Thumbnail -->
                                                    <div class="video-thumbnail-wrapper">
                                                        <!-- Com imagem (YouTube / custom) -->
                                                        <v-img
                                                            v-if="getVideoThumbnail(video)"
                                                            :src="getVideoThumbnail(video)"
                                                            height="170"
                                                            class="video-thumbnail"
                                                        >
                                                            <div class="video-overlay d-flex align-center justify-center">
                                                                <v-btn fab small color="white" elevation="4" class="play-btn">
                                                                    <v-icon color="#006DB6">mdi-play</v-icon>
                                                                </v-btn>
                                                            </div>
                                                            <!--<div class="lang-badge">
                                                                        <img :src="video.lang_icon" width="28" height="20" style="border-radius: 4px; border: 1.5px solid white; box-shadow: 0 2px 6px rgba(0,0,0,0.5); display: block;" />
                                                                    </div>-->
                                                                    <div class="lang-badge">
                                                                    <img
                                                                        :src="video.lang_icon"
                                                                        width="22"
                                                                        height="22"
                                                                        style="
                                                                            border-radius: 50%;
                                                                            border: 1.5px solid white;
                                                                            box-shadow: 0 2px 6px rgba(0,0,0,0.5);
                                                                            display: block;
                                                                            object-fit: cover;
                                                                            object-position: center;
                                                                        "
                                                                    />
                                                                </div>
                                                            <div v-if="video.duration" class="duration-badge">
                                                                <span>{{ video.duration }}</span>
                                                            </div>
                                                        </v-img>

                                                        <!-- Sem imagem — placeholder para vídeos locais -->
                                                        <div v-else class="video-placeholder d-flex align-center justify-center" style="height: 170px">
                                                            <div class="video-overlay d-flex align-center justify-center">
                                                                <v-btn fab small color="white" elevation="4" class="play-btn">
                                                                    <v-icon color="#006DB6">mdi-play</v-icon>
                                                                </v-btn>
                                                            </div>
                                                            <v-icon size="48" color="rgba(255,255,255,0.5)">mdi-video</v-icon>
                                                            <div class="lang-badge">
                                                                <v-avatar size="22" style="border: 1.5px solid white">
                                                                    <v-img :src="video.lang_icon"></v-img>
                                                                </v-avatar>
                                                            </div>
                                                            <div v-if="video.duration" class="duration-badge">
                                                                <span>{{ video.duration }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Info -->
                                                    <v-card-text class="pb-1 pt-2 px-3">
                                                        <div class="video-title dark-blue-color">{{ tb(video.title) }}</div>
                                                        <div v-if="video.description" class="video-description grey--text text--darken-1 mt-1">
                                                            {{ tb(video.description) }}
                                                        </div>
                                                    </v-card-text>

                                                    <v-card-actions class="px-3 pt-0 pb-2">
                                                        <span class="text-caption grey--text">{{ video.date }}</span>
                                                        <v-spacer></v-spacer>
                                                        <v-tooltip bottom content-class="myprovet-tooltip">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon x-small v-on="on" v-bind="attrs" @click.stop="shareVideo(video)">
                                                                    <v-icon small color="grey">mdi-share-variant</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ $t('tutorials.share') }}</span>
                                                        </v-tooltip>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                                </div>
                            </v-row>
                        </template>

                    </app-card>
                </div>
            </v-col>
        </v-row>

        <!-- ── Dialog Player ── -->
        <v-dialog v-model="videoDialog" max-width="75vw" width="900px" :persistent="true">
            <v-card v-if="selectedVideo" class="rounded-lg overflow-hidden">

                <!-- Header -->
                <v-toolbar flat dark color="#006DB6" dense>
                    <v-avatar size="20" class="mr-2">
                        <v-img :src="selectedVideo.lang_icon"></v-img>
                    </v-avatar>
                    <v-toolbar-title class="text-subtitle-1">{{ tb(selectedVideo.title) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeVideo">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- Player -->
                <!----><v-responsive :aspect-ratio="16/9" class="black">
                    <!-- Vídeo local -->
                    <video
                        v-if="selectedVideo.video_source === 'local'"
                        ref="localVideoPlayer"
                        :src="selectedVideo.url"
                        controls
                        autoplay
                        preload="auto"
                        controlsList="nodownload"
                        oncontextmenu="return false"
                        width="100%"
                        height="100%"
                        style="display: block; background: #000"
                    ></video>

                    <!-- YouTube / Vimeo / Externo -->
                    <iframe
                        v-else
                        :src="autoplayUrl(selectedVideo.url)"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        width="100%"
                        height="100%"
                        style="display: block"
                    ></iframe>
                </v-responsive>

                <!-- Descrição -->
                <v-card-text v-if="selectedVideo.description" class="pt-3 pb-2 dark-blue-color">
                    {{ tb(selectedVideo.description) }}
                </v-card-text>

            </v-card>
        </v-dialog>

        <!-- ── Snackbar de partilha ── -->
        <v-snackbar v-model="snackbar" timeout="3000" bottom color="#006DB6">
            <v-icon small class="mr-2">mdi-check-circle</v-icon>
            {{ $t('tutorials.linkCopied') }}
        </v-snackbar>

    </div>
</template>

<script>
import MainLayout from '@/Layouts/MainLayout';
import { axios } from '@/Services/Backend';

export default {
    layout: MainLayout,

    props: {
        categories: {
            type: Array,
            default: () => [],
        },
    },

    data: () => ({
        allCategories: [],
        isLoading: false,
        search: '',
        searchTimeout: null,
        selectedLang: 'all',
        sortOrder: 'az', // 'az' | 'za'
        videoDialog: false,
        selectedVideo: null,
        snackbar: false,
        generatedThumbnails: {},
    }),

    computed: {
        sortedCategories() {
            const lang   = this.selectedLang;
            const search = (this.search || '').trim().toLowerCase();

            return this.allCategories
                .map(cat => ({
                    ...cat,
                    items: [...(cat.items || [])]
                        .filter(v => !lang || lang === 'all' || v.lang === lang)
                        .filter(v => !search || (v.title || '').toLowerCase().includes(search)),
                }))
                .filter(cat => cat.items.length > 0)
                .sort((a, b) => {
                    if (this.sortOrder === 'za') {
                        return (b.name || '').localeCompare(a.name || '', 'pt');
                    }
                    return (a.name || '').localeCompare(b.name || '', 'pt');
                });
        },
    },

    watch: {
        selectedLang(val) {
            if (val === undefined) {
                this.$nextTick(() => { this.selectedLang = 'all'; });
                return;
            }
        },
    },
    beforeDestroy() {
        //window.removeEventListener('resize', this.computeDatatableSize);
    },
    mounted() {
        //this.prepareResponsiveBehaviour();
        this.fetchVideos().then(() => {
        const videoId = new URLSearchParams(window.location.search).get('video');
        if (videoId) {
            const video = this.allCategories
                .flatMap(cat => cat.items)
                .find(v => v.id == videoId);
            if (video) this.openVideo(video);
        }
        });
    },

    methods: {

        fetchVideos() {
            this.isLoading = true;

            return axios.get('/api/tutorials-videos')
                .then(({ data }) => {
                    const raw = Array.isArray(data) ? data : (data.data ?? []);
                    this.allCategories = raw.map(cat => ({
                        ...cat,
                        items: cat.items || [],
                    }));
                    this.$nextTick(() => this.generateAllLocalThumbnails());
                })
                .catch(() => {
                    this.allCategories = [];
                    this.showError && this.showError(this.$t('tutorials.loadError'));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onSearchInput() {
            // Filtro local — sem fetch adicional
        },

        openVideo(video) {
            this.selectedVideo = video;
            this.videoDialog = true;
        },

        closeVideo() {
            this.videoDialog = false;
            setTimeout(() => { this.selectedVideo = null; }, 300);
        },

        shareVideo(video) {
            const text = `${window.location.origin}/tutorials?video=${video.id}`;
            navigator.clipboard.writeText(text).then(() => {
                this.snackbar = true;
            });
        },

        getVideoThumbnail(video) {
            // 1. Imagem personalizada definida no backoffice
            if (video.preview_image) return video.preview_image;

            // 2. Thumbnail gerado via canvas (vídeos locais)
            if (this.generatedThumbnails[video.id]) return this.generatedThumbnails[video.id];

            // 3. Preview automático YouTube
            if (video.video_source === 'youtube' && video.url) {
                const ytMatch = video.url.match(/(?:youtube\.com\/embed\/|youtu\.be\/)([^?&]+)/);
                if (ytMatch) return `https://img.youtube.com/vi/${ytMatch[1]}/mqdefault.jpg`;
            }

            // 4. Sem thumbnail — mostrar placeholder
            return null;
        },

        autoplayUrl(url) {
            if (!url) return url;
            try {
                const u = new URL(url);
                u.searchParams.set('autoplay', '1');
                if (u.hostname.includes('youtube')) {
                    u.searchParams.set('mute', '0');
                }
                return u.toString();
            } catch {
                return url + (url.includes('?') ? '&' : '?') + 'autoplay=1';
            }
        },

        generateLocalThumbnail(video) {
            if (!video.url || video.video_source !== 'local') return;
            if (this.generatedThumbnails[video.id]) return;

            const videoEl = document.createElement('video');
            videoEl.crossOrigin = 'anonymous';
            videoEl.muted = true;
            videoEl.preload = 'metadata';
            videoEl.src = video.url;

            videoEl.addEventListener('loadedmetadata', () => {
                videoEl.currentTime = Math.max(2, videoEl.duration * 0.1);
            });

            videoEl.addEventListener('seeked', () => {
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = 480;
                    canvas.height = 270;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);
                    const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                    this.$set(this.generatedThumbnails, video.id, dataUrl);
                } catch (e) {
                    // CORS ou outro erro
                }
                videoEl.src = '';
            });

            videoEl.load();
        },

        generateAllLocalThumbnails() {
            this.allCategories.forEach(cat => {
                (cat.items || []).forEach(video => {
                    if (video.video_source === 'local' && !video.preview_image) {
                        this.generateLocalThumbnail(video);
                    }
                });
            });
        },
    },
};
</script>

<style scoped lang="scss">
/*.tutorials-page .myprovet-card{
    max-height: 820px!important;
    overflow-y: scroll!important;
}*/
.tutorials-page {
    .theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn{
      border: none !important;
    }
}
.categories-scroll-wrapper {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;
}

@media (max-width: 599px) {
    .tutorials-page {
        .categories-scroll-wrapper {
            max-height: none !important;
            overflow-y: visible !important;
            overflow-x: hidden !important;
            padding-right: 0 !important;
            width: 100% !important;
        }
    }
}
/* Scrollbar personalizada */
/*.categories-scroll-wrapper::-webkit-scrollbar {
    width: 6px;
}

.categories-scroll-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.categories-scroll-wrapper::-webkit-scrollbar-thumb {
    background: #154579;
    border-radius: 4px;
}

.categories-scroll-wrapper::-webkit-scrollbar-thumb:hover {
    background: #0d2d52;
}*/
.video-card {
    cursor: pointer;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    border: 1px solid #e8e8e8 !important;
}

.video-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 109, 182, 0.15) !important;
}

.video-thumbnail-wrapper {
    position: relative;
    overflow: hidden;
}

.video-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0);
    transition: background 0.25s ease;
}

.video-card:hover .video-overlay {
    background: rgba(0, 0, 0, 0.35);
}

.play-btn {
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.video-card:hover .play-btn {
    opacity: 1;
    transform: scale(1);
}

.lang-badge {
    position: absolute;
    top: 8px;
    left: 8px;
}

.duration-badge {
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.65);
    color: white;
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
}

.video-title {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.video-description {
    font-size: 0.78rem;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.dark-blue-color {
    color: #006DB6;
}

.title-text {
    font-weight: 700;
}

.video-placeholder {
    position: relative;
    background: linear-gradient(135deg, #005a99 0%, #006DB6 60%, #004d80 100%);
    overflow: hidden;
}

.filter-toggle {
    border: 1px solid #d0d0d0;
    border-radius: 8px !important;
    overflow: hidden;
}

.filter-btn {
    background: white !important;
    color: #006DB6 !important;
    font-size: 12px !important;
    min-width: 52px !important;
}

.filter-btn.v-btn--active {
    background: #006DB6 !important;
    color: white !important;
}
.video-card:focus {
    outline: none !important;
    box-shadow: 0 8px 24px rgba(0, 109, 182, 0.15) !important;
}

.video-card:focus::before {
    border-radius: 24px !important;
    opacity: 0 !important;
}
.video-card {
    cursor: pointer;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    border: 1px solid #e8e8e8 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.video-card .v-card__text {
    flex: 1;
}
.video-thumbnail-wrapper {
    position: relative;
    overflow: hidden;
    height: 170px;
}

.video-thumbnail-wrapper .v-image {
    height: 170px !important;
}

.video-placeholder {
    height: 170px !important;
}

.lang-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
}

</style>
